<template>
    <div v-html="dcontent.data.content">
   </div>
</template>

<script>

export default {
    data() {
        return {

        }
    },
    props: {
        dcontent: Object
    }
}
</script>
